import React from 'react'
import { NavigationStackScreenComponent } from 'react-navigation-stack'
import { BaseNavigationProps } from '../../navigation/_root'
import {
  ATLButton,
  ATLSpacing,
  ATLTextHead,
  ButtonTypeEnum,
  SpacingSizesEnum,
  TextAlignmentEnum,
} from '@appsimples/atlantica-react-native'
import { atlTheme } from '../../atlTheme'
import styled from 'styled-components/native'
import { Coordinator } from '../../navigation/coordinator/coordinator'
import { formatMessage } from '../../constants/strings/intl/intlHooks'
import { messages } from '../../constants/strings/messages'
import { useGlobal } from '../../global/useGlobal'
import { usePromise } from '../../utils/hooks/usePromise'
import { recoverPassword } from '../../services/auth/recoverPassword'
import { showErrorSnackbar, showMessageSnackbar, SnackbarDuration } from '../../components/snackbar/Snackbar'
import { Loading } from '../../components/loading/Loading'
import { graphQLErrorsCode } from '../LoginScreen/common'

const RedefinePasswordContainer = styled.SafeAreaView`
  background-color: ${atlTheme.ColorSurface};
  height: 100%;
`
const MessageContainer = styled.View`
  width: 100%;
  margin-top: 30%;
  margin-right: ${atlTheme.SpacingMarginal};
`
const MessageTextBody = styled.Text`
  font-style: normal;
  font-weight: normal;
  font-size: ${atlTheme.FontSizeBody};
  line-height: ${atlTheme.LineHeightBase};
  flex: none;
  margin: 0px ${atlTheme.SpacingMarginal}px;
  display: flex;
  align-items: flex-end;
`
const ButtonContainer = styled.View`
  position: absolute;
  width: 100%;
  left: 0px;
  bottom: ${atlTheme.SpacingIntersection}px;
`

export const PasswordRecoverySecondScreen: NavigationStackScreenComponent<BaseNavigationProps> = () => {
  const [currentCpf] = useGlobal('currentCpfForPasswordRecovery')

  const { loading: isResendingEmail, request: doRecoverPassword } = usePromise(recoverPassword, [], {
    onSuccess: () =>
      showMessageSnackbar(
        formatMessage(messages.forgotPassword_resendPassword_success),
        SnackbarDuration.LONG,
        atlTheme.ColorHighContrast
      ),
    onError: (e: any) => {
      console.log('e', e)
      if (e?.graphQLErrors[0]?.extensions.code === graphQLErrorsCode.USER_NOT_FOUND) {
        showErrorSnackbar(formatMessage(messages.forgotPassword_resendPassword_failure_userNotFound))
        return
      }
      showErrorSnackbar(formatMessage(messages.forgotPassword_resendPassword_failure))
    },
  })

  const resendPassword = () => {
    doRecoverPassword({
      cpf: currentCpf,
    })
  }

  return (
    <RedefinePasswordContainer>
      <MessageContainer>
        <ATLTextHead
          textAlignment={TextAlignmentEnum.left}
          labelBaseProps={{
            fontSize: atlTheme.FontSizeDisplay,
            lineHeight: atlTheme.LineHeightDisplay,
          }}
        >
          {formatMessage(messages.forgotPassword_passwordSentTitle)}
        </ATLTextHead>
        <MessageTextBody>
          {`${formatMessage(messages.forgotPassword_passwordSent)} ${formatMessage(
            messages.forgotPassword_checkYourInbox
          )}`}
        </MessageTextBody>
      </MessageContainer>
      <ATLSpacing type={SpacingSizesEnum.marginal} />
      {isResendingEmail ? (
        <Loading color={atlTheme.ColorBrand2Default} />
      ) : (
        <ATLButton
          type={ButtonTypeEnum.label}
          title={formatMessage(messages.forgotPassword_resendPassword)}
          buttonBaseProps={{ textColorComplementary: atlTheme.ColorBrand2Default }}
          onPress={resendPassword}
        />
      )}
      <ATLSpacing type={SpacingSizesEnum.distribute} />
      <ButtonContainer>
        <ATLButton
          title={formatMessage(messages.forgotPassword_goToLogin)}
          onPress={Coordinator.goToLogin}
          buttonBaseProps={{
            borderRadius: 100,
          }}
        />
      </ButtonContainer>
    </RedefinePasswordContainer>
  )
}
PasswordRecoverySecondScreen.navigationOptions = {
  headerShown: false,
}
